import React from 'react'
import { Form, Select } from 'antd'
import { MOBILE, PHONE_TYPES_MAP } from '@components/Signup/constants'
import styles from './PhoneFormFields.module.scss'
import InputMask from 'react-input-mask'

const { Option } = Select

const labelCol = { span: 24 }

const phoneOptions = PHONE_TYPES_MAP.map(({ name, value }) => (
  <Option
    value={value}
    key={value}
  >
    {name}
  </Option>
))

const validPhoneNumber = value => value && value.match(/\d/g).length === 10

const PhoneFormFields = ({
  formRef,
  initialValues: {
    phone,
    phoneType,
  },
}) => {
  // Manually reset phone / phone_type to avoid buggy dropdown error clearing from async
  // form validation
  const clearPhoneTypeError = () => setTimeout(() => {
    formRef.current && formRef.current.resetFields(['phone_type'])
  }, 200)

  return <div className={styles.phoneInputs}>
    <Form.Item
      label='Phone Number'
      labelCol={labelCol}
      name='phone'
      initialValue={phone}
      rules={[
        {
          required: true,
          message: '',
        },
        () => ({
          validator(_, value) {
            if (validPhoneNumber(value)) {
              return Promise.resolve()
            }
            return Promise.reject(new Error('Please enter a valid phone number'))
          },
        }),
      ]}
    >
      <InputMask
        className={styles.phoneNumberInput}
        onChange={clearPhoneTypeError}
        mask="(999) 999-9999"
        maskChar=" "
        type='tel'
      />
    </Form.Item>
    <Form.Item
      className={styles.phoneDropdown}
      name='phone_type'
      initialValue={phoneType || MOBILE}
      rules={[
        ({ getFieldValue }) => ({
          validator() {
            const phoneNumber = getFieldValue('phone')
            if (validPhoneNumber(phoneNumber)) {
              return Promise.resolve()
            }
            // Must have blank space otherwise page explodes
            // This empty error bumps the dropdown up otherwise
            // it is not aligned with the input on the left
            return Promise.reject(new Error(' '))
          },
        }),
      ]}
    >
      <Select
        defaultActiveFirstOption={true}
        name='phone_type'
      >
        {phoneOptions}
      </Select>
    </Form.Item>
  </div>
}

export default PhoneFormFields
